import React from "react";
import { Link } from "react-router-dom";

/**
 * Brand logo/wordmark for in7sekunden.
 * Minimal, mono, premium. Small wave-dot mark evokes the NFC tap.
 */
export function BrandMark({ className = "", markClassName = "", textClassName = "" }) {
  return (
    <Link
      to="/"
      className={`group inline-flex items-center gap-2.5 select-none ${className}`}
      aria-label="in7sekunden"
      data-testid="brand-logo-link"
    >
      <span
        aria-hidden
        className={`relative grid place-items-center h-8 w-8 rounded-full border border-brand-ink/15 bg-white transition-all duration-300 group-hover:border-brand-ink ${markClassName}`}
      >
        <svg viewBox="0 0 32 32" className="h-4 w-4">
          <circle cx="16" cy="16" r="2" fill="currentColor" />
          <path
            d="M10.5 20.5c1.2-3.8 4-6.5 5.5-6.5s4.3 2.7 5.5 6.5"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            fill="none"
          />
          <path
            d="M7 23.5c2-5.5 6-9 9-9s7 3.5 9 9"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            fill="none"
            opacity="0.55"
          />
        </svg>
      </span>
      <span className={`font-heading font-semibold text-[17px] tracking-tight text-brand-ink ${textClassName}`}>
        in<span className="text-brand-champagne">7</span>sekunden
      </span>
    </Link>
  );
}

export default BrandMark;
